

// Video player

document.addEventListener("DOMContentLoaded", () => {
  const wrappers = document.querySelectorAll("[data-video-controller]");
  let currentVideo = null;
      
  console.log("clicked")
  wrappers.forEach(wrapper => {
    const video = wrapper.querySelector("video");
    const btn = wrapper.querySelector(".play-button");

    if (!video || !btn) return;

    video.pause();
    video.currentTime = 0;
    video.setAttribute("playsinline", "");
    btn.textContent = "▶";
    btn.style.opacity = "1";

    const playVideo = async () => {
      try {
        if (currentVideo && currentVideo !== video) {
          currentVideo.pause();
          const b = currentVideo.parentElement.querySelector(".play-button");
          if (b) b.textContent = "▶";
        }
        await video.play();
        currentVideo = video;
        btn.style.opacity = "0";
      } catch (err) {
        console.warn("Playback blocked:", err.name);
        btn.style.opacity = "1";
      }
    };

    btn.addEventListener("click", async e => {
      e.preventDefault();
      e.stopImmediatePropagation();

      if (video.paused) {
        playVideo();
      } else {
        video.pause();
        btn.style.opacity = "1";
        if (currentVideo === video) currentVideo = null;
      }
    });

    // Update button state on play/pause/ended
    video.addEventListener("play", () => {
      btn.textContent = "⏸";
    });
    video.addEventListener("pause", () => {
      btn.textContent = "▶";
      if (currentVideo === video) currentVideo = null;
    });
    video.addEventListener("ended", () => {
      video.currentTime = 0;
      btn.textContent = "▶";
      if (currentVideo === video) currentVideo = null;
    });
  });
});


document.addEventListener('DOMContentLoaded', () => {
  const getOrdinal = (n) => {
    const s = ["th", "st", "nd", "rd"];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  };

  const updateDeliveryDate = () => {
    // Target both classes and IDs to cover the theme and the Kaching app
    const deliveryElements = document.querySelectorAll('.delivery-date, #delivery-date');
    if (deliveryElements.length === 0) return;

    const today = new Date();
    let deliveryDate = new Date();

    // Your logic: today + 3 days
    deliveryDate.setDate(today.getDate() + 3);

    const day = deliveryDate.getDate();
    const month = deliveryDate.toLocaleString('default', { month: 'short' });

    const deliveryText = `Order now and get it by <span style="font-weight: 700;">${getOrdinal(day)} ${month}</span>`;

    deliveryElements.forEach(el => {
      // Only update if the content is different to prevent flickering
      if (el.innerHTML !== deliveryText) {
        el.innerHTML = deliveryText;
      }
    });
  };

  // 1. Initial run for static pages (Product pages)
  updateDeliveryDate();

  // 2. WATCHER: This ensures it works with Kaching Cart
  // It listens for the drawer to be injected and runs the update
  const observer = new MutationObserver((mutations) => {
    updateDeliveryDate();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // 3. Midnight Refresh Logic
  const now = new Date();
  const msUntilMidnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1) - now;

  setTimeout(() => {
    updateDeliveryDate();
    setInterval(updateDeliveryDate, 24 * 60 * 60 * 1000);
  }, msUntilMidnight);
});

